import React, { useEffect, useState } from 'react';
import './FormReaders.css';
import FormTitle from '../../../components/FormTitle/FormTitle';
import { PiSecurityCameraBold } from 'react-icons/pi';
import { ReaderModel } from '../../../constants/readers-model';
import Loader from '../../../components/Loader/Loader';
import Form from '../../../components/Form/Form';
import { ReaderModelEnum } from '../../../constants/readers-model';
import Input from '../../../components/Input/Input';
import ToggleButton from '../../../components/ToggleButton/ToggleButton';
import { PartialFormAlphadigi } from './PartialFormAlphadigi';
import { PartialFormAvicam } from './PartialFormAvicam';
import { PartialFormCtrlID } from './PartialFormCtrlID';
import { PartialFormIntelbras } from './PartialFormIntelbras';
import { PartialFormHikvision } from './PartialFormHikvision';
import { PartialFormPositivo } from './PartialFormPositivo';
import { PartialFormSemParar } from './PartialFormSemParar';
import { PartialFormUniview } from './PartialFormUniview';
import { PartialFormQrcode } from './PartialFormQrcode';
import { useUserStore } from '../../../contexts/userStore';
import { SelectAccessGroup } from '../../../components/SelectAccessGroup/SelectAccessGroup';
import { SelectAccessModule } from '../../../components/SelectAccessModule/SelectAccessModule';
import ReadersService from '../../../services/ReadersService';
import { Link, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from "uuid";
import { IoAlertCircleOutline } from 'react-icons/io5';
import { PartialFormWeg } from './PartialFormWeg';
import { useTranslation } from 'react-i18next';
import { TbDoorEnter, TbDoorExit } from 'react-icons/tb';

const ReaderForms = {
   [ReaderModelEnum.AlphaDigi]: PartialFormAlphadigi,
   [ReaderModelEnum.Avicam]: PartialFormAvicam,
   [ReaderModelEnum.CtrlID]: PartialFormCtrlID,
   [ReaderModelEnum.Intelbras]: PartialFormIntelbras,
   [ReaderModelEnum.Hikvision]: PartialFormHikvision,
   [ReaderModelEnum.Positivo]: PartialFormPositivo,
   [ReaderModelEnum.QRCODE]: PartialFormQrcode,
   [ReaderModelEnum.SEM_PARAR]: PartialFormSemParar,
   [ReaderModelEnum.Uniview]: PartialFormUniview,
   [ReaderModelEnum.Weg]: PartialFormWeg,
}

export function FormReaders({ model, ...props }) {
   const modelData = ReaderModel[model];
   const [showLoader, setShowLoader] = useState(false);
   const [name, setName] = useState(props.reader?.name);
   const [ip, setIp] = useState(props.reader?.ip);
   const [editablePort, setEditablePort] = useState(false);
   const [port, setPort] = useState(props.reader?.port);
   const [direction, setDirection] = useState(props.reader?.direction ?? '0');
   const [ignoreUser, setIgnoreUser] = useState(props.reader?.ignoreUser);
   const [enabled, setEnabled] = useState(props.reader?.enabled);
   const [modelState, setModel] = useState(model);
   const [configuration, setConfiguration] = useState(props.reader?.configuration);
   const [accessModule, setAccessModule] = useState(props.reader?.accessModule);
   const [group, setGroup] = useState(props.reader?.group);
   const [serviceConfig, setServiceConfig] = useState(undefined);
   const { selectedCondominio, selectedLicenceId } = useUserStore();
   const navigate = useNavigate();
   const { t } = useTranslation();

   console.log(selectedLicenceId);

   function buildPayload() {
      const [accessModuleId, accessModuleIndex] = accessModule.split(':');
      const payload = {
         name,
         ip,
         port,
         model: modelData.key,
         configuration,
         direction,
         ignoreUser,
         enabled,
         accessModuleId: Number(accessModuleId),
         accessGroupId: Number(group),
         licenseId: selectedLicenceId,
         uuid: props.reader?.uuid ?? uuidv4(),
         id_condominium: selectedCondominio,
      }
      if (props.reader?.id) {
         payload.id = props.reader.id;
      }
      if (accessModuleIndex) {
         payload.accessModuleIndex = accessModuleIndex;
      }
      return payload;
   }

   async function fetchConfig(model) {
      const response = await ReadersService.getReaderServiceConfig(model, selectedCondominio, selectedLicenceId);
      const config = response.data;
      setServiceConfig(config && config !== '' ? config : null);
   }

   useEffect(() => {
      fetchConfig(modelData.key);
      if (props.reader) {
         setName(props.reader.name);
         setIp(props.reader.ip);
         setPort(props.reader.port);
         setDirection(`${props.reader.direction}`);
         setIgnoreUser(props.reader.ignoreUser);
         setEnabled(props.reader.enabled);
         setModel(props.reader.model);
         setConfiguration(props.reader.configuration);
         setAccessModule(props.reader.accessModuleIndex != null ? `${props.reader.accessModuleId}:${props.reader.accessModuleIndex}` : `${props.reader.accessModuleId}`);
         setGroup(props.reader.accessGroupId ? `${props.reader.accessGroupId}` : null);
      }
   }, [props.reader, selectedCondominio, selectedLicenceId])

   function handleSubmit(event) {
      if (props.type === "edicao") {
         handleEdit(event);
         return;
      }
      handleCreate(event);
   }

   async function handleCreate(event) {
      event.preventDefault();
      const payload = buildPayload();
      const response = await ReadersService.createReader(payload);
      if (response.data.id) navigate(`/consulta-readers`, {
         state: { refresh: true }
      });
   }

   async function handleEdit(event) {
      event.preventDefault();
      const payload = buildPayload();
      const response = await ReadersService.updateReader(props.reader.id, payload);
      if (response.data.id) navigate(`/consulta-readers`, {
         state: { refresh: true }
      });
   }

   async function handleDelete() {
      if (!props.reader) return;
      await ReadersService.deleteReader(props.reader.id);
      navigate(`/consulta-readers`, {
         state: { deletedId: props.reader.id }
      })
   }

   function handleClickEditButton() {
      if (!props.reader) return;
      navigate(`/readers/${props.reader.id}`, {
         state: props.reader
      });
   }

   return (
      <React.Fragment>
         <FormTitle
            type={props.type}
            icon={<PiSecurityCameraBold size={20} />}
            tituloConsulta={props.reader?.name || null}
            tituloCadastro={`Cadastro de Dispositivo ${modelData.name}`}
            backRoute={"/consulta-readers"}
         />
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               type={props.type}
               handleDelete={handleDelete}
               handleClickEdit={handleClickEditButton}
               navigateCancelUrl="../consulta-readers"
               deleteButNotSynqed={props.reader?.deletedAt ? true : false}
            >
               {(serviceConfig === null || (serviceConfig && (!serviceConfig.enabled || serviceConfig.status !== 'synced'))) && (
                  <div className='alert alert-warning'>
                     <span className='inline-flex flex-row items-center flex-wrap gap-1.5'>
                        <b className='inline-flex flex-row items-center gap-1'>
                           <IoAlertCircleOutline size={18} />
                           {t("alerts.attention")}:
                        </b>
                        <span>{t("alerts.noReaderServiceAlert", { readerName: modelData.name })}</span>
                        <Link to={`../configuracoes-gerais-leitoras/${modelData.slug}`}>
                           {t("common.configure")}
                        </Link>
                     </span>
                  </div>
               )}
               <div className={`grid ${props.type === "consulta" ? "grid-cols-1" : "grid-cols-2"} gap-2.5 w-full`}>
                  <Input
                     name="name"
                     id="name"
                     labelText={`${t("common.name")}*`}
                     value={name}
                     onChange={({ target }) => setName(target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <SelectAccessModule formMode={props.type} accessModule={accessModule} onChange={(value) => setAccessModule(value)} />
                  <SelectAccessGroup formMode={props.type} group={group} onChange={(value) => setGroup(value)} required={false} />
                  <div>
                     <label className="input-label">
                        {t("common.direction")}
                     </label>
                     <div className='flex flex-row items-center gap-0 mt-1! text-sm! py-0! select-none!'>
                        <label className='inline-flex items-center text-(--textColor) gap-1'>
                           <span className={`${direction === '0' ? 'text-(--entryColor)' : 'text-(--textColor)'} w-[80px]! font-semibold! inline-flex justify-center items-center gap-1.5! h-(--inputHeight) bg-(--inputBackgroundColor) shadow-(--box-shadow)! border! ${direction === '0' ? 'border-(--entryColor)!' : 'border-(--borderColor)!'} rounded-l-(--borderRadius) px-3.5!`}>
                              <TbDoorEnter size={17} />
                              {t("common.entry")}
                           </span>
                           <input
                              type='radio'
                              disabled={props.type === "consulta"}
                              name='direction'
                              value={`0`}
                              checked={direction === '0'}
                              className='hidden accent-(--primaryColor)'
                              onChange={e => setDirection(e.target.value)}
                           />
                        </label>
                        <label className='inline-flex items-center text-(--textColor) gap-1'>
                           <span className={`${direction === '1' ? 'text-(--exitColor)' : 'text-(--textColor)'} w-[80px]! font-semibold! inline-flex justify-center items-center gap-1.5! h-(--inputHeight) bg-(--inputBackgroundColor) shadow-(--box-shadow)! border! ${direction === '1' ? 'border-(--exitColor)!' : 'border-(--borderColor)!'} rounded-r-(--borderRadius) px-3.5!`}>
                              < TbDoorExit size={17} />
                              {t("common.exit")}
                           </span>
                           <input
                              type='radio'
                              disabled={props.type === "consulta"}
                              name='direction'
                              value={`1`}
                              checked={direction === '1'}
                              className='hidden accent-(--primaryColor)'
                              onChange={e => setDirection(e.target.value)}
                           />
                        </label>
                     </div>
                  </div>
                  <div className='flex flex-row items-start gap-2.5'>
                     <Input
                        name="ip"
                        id="ip"
                        labelText={`${t("equipment.ipAddress")}*`}
                        placeholder="XXX.XXX.XXX.XXX"
                        value={ip}
                        onChange={({ target }) => setIp(target.value)}
                        disabled={props.type === "consulta"}
                        required={true}
                     />
                     {editablePort && (
                        <div className='w-[160px]'>
                           <Input
                              name="port"
                              id="port"
                              labelText={`${t("equipment.port")}*`}
                              value={port}
                              onChange={({ target }) => setPort(target.value)}
                              disabled={props.type === "consulta"}
                              required={true}
                           />
                        </div>
                     )}
                  </div>
                  <div className='flex flex-row items-center gap-3.5 my-2'>
                     <ToggleButton
                        style={{ width: 'fit-content', paddingTop: '12px' }}
                        label={`${t("common.enabled")}`}
                        onChange={(e) => setEnabled(e.target.checked)}
                        disabled={props.type === "consulta"}
                        selected={enabled}
                     />
                     <ToggleButton
                        style={{ width: 'fit-content', paddingTop: '12px' }}
                        label={`${t("equipment.ignoreUser")}`}
                        onChange={(e) => setIgnoreUser(e.target.checked)}
                        disabled={props.type === "consulta"}
                        selected={ignoreUser}
                     />
                  </div>
               </div>
               {props.type !== 'consulta' && (
                  <>
                     {React.createElement(ReaderForms[model], { configuration, setConfiguration, type: props.type, editablePort, setEditablePort })}
                  </>
               )}
            </Form>
         )
         }
      </React.Fragment >
   );
}